<script>
    import 'bulma/css/bulma.css';
    import '@creativebulma/bulma-divider/src/docs/static/css/bulma-divider.css';
    import SnapshotApi from "./application/api/SnapshotAPI.ts";
    import {init, addMessages} from "svelte-i18n";
    import Menu from "./syllabus/container/SyllabusMenuBar.svelte";
    import Panel from "./syllabus/container/SyllabusPanel.svelte";
    import {Notification, Icon} from 'svelma';
    import {Stretch} from "svelte-loading-spinners";
    import {_} from "svelte-i18n";
    import {writable} from "svelte/store";

    import en from "./syllabus/container/en.json";
    import hu from "./syllabus/container/hu.json";
    import BackgroundElement from "./syllabus/presentational/BackgroundElement.svelte";

    let languages = writable(localStorage.getItem("lang") !== null ? localStorage.getItem("lang") : 'hu');

    addMessages('en', en);
    addMessages('hu', hu);

    $: {
        init({fallbackLocale: 'hu', initialLocale: $languages,});
        localStorage.setItem("lang", $languages);
    }

    let snapshotsPromise = SnapshotApi.getSnapshots();
    let selected = writable(0);
    let option = writable({});

    function saveNotificationCloseState() {
        localStorage.setItem("notificationState", "set");
    }
</script>

{#await snapshotsPromise}
    <BackgroundElement/>
    <div class="columns p-6 mt-6 has-text-centered title has-text-white">
        <div class="column mt-6 has-text-weight-bold">
            {$_('main.loading')}
        </div>
    </div>
    <div class="columns">
        <div class="column has-text-centered">
            <Stretch size="240" color="#FFFFFF" unit="px" duration="1s"/>
        </div>
    </div>
    <div class="columns">
        <div class="column has-text-centered has-text-white has-text-weight-bold">
            PTE MIK - 2021
        </div>
    </div>
{:then snapshots}
    <BackgroundElement/>
    <div class:is-hidden={localStorage.getItem("notificationState")==="set"}>
        <Notification on:close={saveNotificationCloseState} type="is-warning">
            {$_('panel.notification')}
            <Icon pack="fa" size="is-large" icon="exclamation-circle"/>
        </Notification>
    </div>
    <Menu snapshots={snapshots} selected={selected} option={option} settings={languages} languages={languages}/>
    <Panel snapshots={snapshots} selected={selected} option={option} languages={languages}/>
{:catch error}
    <p>{error.message}</p>
{/await}